import type { JSX } from "react";
export function AsurionA({ fill = "white" }: { fill?: string }): JSX.Element {
    return (
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.84242 12.6093H12.4763V6.60803C12.4763 3.20731 9.70906 0.473389 6.34167 0.473389C2.97429 0.473389 0.207031 3.20731 0.207031 6.60803C0.207031 10.0088 2.97429 12.7427 6.34167 12.7427C7.50859 12.7427 8.80887 12.4093 9.84242 11.2424V12.6093ZM6.34167 10.1088C4.40793 10.1088 2.84093 8.54178 2.84093 6.60803C2.84093 4.67428 4.40793 3.10728 6.34167 3.10728C8.27542 3.10728 9.84242 4.67428 9.84242 6.60803C9.84242 8.54178 8.27542 10.1088 6.34167 10.1088Z"
                fill={fill}
            />
        </svg>
    );
}
